import PropTypes from 'prop-types';
import { InventoryService } from '../services/inventory-service';

const StockLevelPropType = PropTypes.shape({
  label: PropTypes.string,
  quantity: PropTypes.number,
  type: PropTypes.oneOf(Object.values(InventoryService.StockLevelQuantityType)),
  unit: PropTypes.any, // unused property based on WebV3Api models
});

export const StockLevelsPropType = PropTypes.arrayOf(StockLevelPropType);

/**
 * @typedef {object} StockLevelPropType
 * @property {string} label
 * @property {number} quantity
 * @property {(
 *   'InventoryProviderSpecified'|
 *   'BlankBox'|
 *   'Allocated'|
 *   'Available'|
 *   'Total'
 * )} type
 * @property {any} unit - unused property based on WebV3Api models
 */

/**
 * @typedef {StockLevelPropType[]} StockLevelsPropType
 */
